import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";
import type { AssistantLinkedTextPart } from "../types";
import { AssistantLinkedText } from "./assistant-linked-text";

interface AssistantActivityLabelProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  active?: boolean;
  parts?: AssistantLinkedTextPart[] | null;
}

export function AssistantActivityLabel({
  children,
  active = false,
  parts,
  className,
  ...props
}: AssistantActivityLabelProps) {
  const label = typeof children === "string" ? children : undefined;

  return (
    <span
      className={cn(
        "assistant-activity-label",
        active && "assistant-activity-label--active",
        className
      )}
      data-active={active ? "true" : "false"}
      data-label={label}
      {...props}
    >
      {label ? <AssistantLinkedText parts={parts} fallback={label} /> : children}
    </span>
  );
}
